<template>
  <el-drawer :visible.sync="visible" direction="rtl" size="50%" :with-header="false" :wrapperClosable="false">
    <div class="form-title">
      <h2>操作日志</h2>
      <button class="link" type="button" @click="close">×</button>
    </div>
    <div class="log-body">
      <WmsTable :columns="columns" :dataSource="logList" :isPagination="false" :hasHeader="false" />
    </div>
  </el-drawer>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import { inboundExceptionLogs } from "@/apis/inHouse";
import { logColumns } from "../data";

export default {
  name: "LogDrawer",
  components: {
    WmsTable,
  },
  data() {
    return {
      // 抽屉显示
      visible: false,
      // 日志列
      columns: logColumns,
      // 日志数据
      logList: [],
    };
  },
  methods: {
    // 打开并加载日志
    open: function (record) {
      this.visible = true;
      this.logList = [];
      inboundExceptionLogs({ exceptionCode: record.exceptionCode }).then((res) => {
        if (res.code === 0) {
          this.logList = res.data || [];
        }
      });
    },
    // 关闭抽屉
    close: function () {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.form-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e2e7ea;
  padding: 18px 24px 14px;
}

.form-title h2 {
  margin: 0;
  font-size: 20px;
}

.link {
  border: 0;
  background: none;
  font-size: 24px;
  color: #71808a;
  cursor: pointer;
}

.log-body {
  padding: 18px 24px;
}
</style>
